import { render, staticRenderFns } from "./PostRegistrationMessage.vue?vue&type=template&id=3104abd0&"
import script from "./PostRegistrationMessage.vue?vue&type=script&lang=js&"
export * from "./PostRegistrationMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports